export default __webpack_public_path__ + "static/media/b-2.83389c8c.png";